module.exports = __webpack_public_path__ + "img/sv.6e4d80c7.svg";